import { render, staticRenderFns } from "./BasicRouterView.vue?vue&type=template&id=9f0b5b18&"
import script from "./BasicRouterView.vue?vue&type=script&lang=js&"
export * from "./BasicRouterView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports